import { render, staticRenderFns } from "./gauge-editor.vue?vue&type=template&id=52549190&scoped=true&"
import script from "./gauge-editor.vue?vue&type=script&lang=ts&"
export * from "./gauge-editor.vue?vue&type=script&lang=ts&"
import style0 from "./gauge-editor.vue?vue&type=style&index=0&id=52549190&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52549190",
  null
  
)

export default component.exports